import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from './AuthProvider';

function PublicRoute({ children }) {
  const { isLoggedIn, isAuthReady } = useContext(AuthContext);

  if (!isAuthReady) return null;
  if (isLoggedIn) return <Navigate to="/" replace />;

  return children;
}

export default PublicRoute;
